import {ActionTypes as Common} from './commonActions';
import * as MessageBox from './messageBox/actions/actionTypes';
import {ActionTypes as Session} from '../session/actions';
import {ActionTypes as Menu} from './menu/actions';
import {ActionTypes as Origin} from '../origin/actions';
import {ActionTypes as Order} from '../order/actions';
import {ActionTypes as Provider} from '../provider/actions';
import {ActionTypes as Parameters} from '../parameter/actions';
import {ActionTypes as ExcelReader} from '../excelReader/actions';
import {ActionTypes as Parts} from '../part/actions';
import {ActionTypes as ProviderConfig} from '../providerConfiguration/actions';
import {ActionTypes as MonthClose} from '../monthClose/actions';
import {ActionTypes as BackOrders} from '../backOrders/actions';
import {ActionTypes as Binning} from '../binning/actions';
import {ActionTypes as Transfers} from '../transfers/actions';
import {ActionTypes as Warehouses} from '../warehouses/actions';
import {ActionTypes as ItemBudget} from '../itemBudget/actions';
import {ActionTypes as PartsMaster} from '../partsMaster/actions';
import {ActionTypes as Lubricants} from '../lubricants/actions';
import {ActionTypes as Picking} from '../picking/actions';
import {ActionTypes as Transport} from '../transport/actions';
import {ActionTypes as PartQuotation} from '../partQuotation/actions';
import {ActionTypes as ProviderOrders} from '../providerOrders/actions';
import {ActionTypes as SalesAndBudgetsLoad} from '../salesAndBudgetsLoad/actions';
import {ActionTypes as InvoiceLoad} from '../invoiceLoad/actions';
import {ActionTypes as ObsolescenceParameters} from '../obsolescenceParameters/actions';
import {ActionTypes as VehiclesAvailability} from '../vehiclesAvailability/actions';
import {ActionTypes as QualityAssuranceOrders} from '../qualityAssuranceOrders/actions';
import {ActionTypes as ServiceReportPart} from '../serviceReportPart/actions';
import {ActionTypes as VehicleEfficiency} from '../vehicleEfficiency/actions';
import {ActionTypes as LogisticsReports} from '../logisticsReports/actions';
import {ActionTypes as StockAdjustment} from '../stockAdjustment/actions';
import {ActionTypes as VehicleHistory} from '../vehicleHistory/actions';
import {ActionTypes as WarrantiesAdmin} from '../adminWarranty/actions';
import {ActionTypes as LogisticOrders} from '../logisticsOrders/actions';
import {ActionTypes as DealerStockOrders} from '../dealerOrders/actions';
import {ActionTypes as PartNumberCode} from '../partNumberCode/actions';
import {ActionTypes as VehicleCombos} from '../vehicleCombos/actions';
import {ActionTypes as MasterVehicle} from '../masterVehicle/actions';
import {ActionTypes as InvoiceQuery} from '../invoiceQuery/actions';
import {ActionTypes as SpecialParts} from '../specialParts/actions';
import {ActionTypes as PartsCatalog} from '../partsCatalog/actions';
import {ActionTypes as PartInvoices} from '../partInvoices/actions';
import {ActionTypes as PriceFactors} from '../priceFactors/actions';
import {ActionTypes as PartsReturns} from '../partsReturns/actions';
import {ActionTypes as VehiclesKpi} from '../vehiclesKpi/actions';
import {ActionTypes as WholeSale} from '../wholeSale/actions';
import {ActionTypes as WaitHappy} from '../waitHappy/actions';
import {ActionTypes as Campaign} from '../campaign/actions';
import {ActionTypes as Accessories} from '../accessories/actions';
import {ActionTypes as Warranties} from '../warranties/actions';
import {ActionTypes as CalendarTems} from '../calendar/actions';
import {ActionTypes as IccMatrix} from '../iccMatrix/actions';
import {ActionTypes as PartsSales} from '../partsSales/actions';
import {ActionTypes as PartAudit} from '../partAudit/actions';
import {ActionTypes as BoReport} from '../boReport/actions';
import {ActionTypes as VehAudi} from '../vehAudi/actions';
import {ActionTypes as Forms} from '../forms/actions';
import {ActionTypes as Dealer} from '../dealer/actions';
import {ActionTypes as Icc} from '../iccChart/actions';
import {ActionTypes as Users} from '../user/actions';
import {ActionTypes as Sets} from '../sets/actions';
import {ActionTypes as Kpis} from '../kpis/actions';
import {ActionTypes as Liquidations} from '../liquidations/actions';
import {ActionTypes as BudgetVehicles} from '../budgetVehicles/actions';
import {ActionTypes as VehicleSaleForecast} from '../vehicleSaleForecast/actions';
import {ActionTypes as DailyVehiclesSalesAndStock} from '../dailyVehiclesSalesAndStock/actions';
import {ActionTypes as DailyVehiclesSalesAndStockSummary} from '../dailyVehiclesSalesAndStockSummary/actions';
import {ActionTypes as DevicesOrders} from '../devices/actions';
import {ActionTypes as Bulletins} from '../bulletins/actions';
import {ActionTypes as LogisticAreas} from '../logisticAreas/actions';
import {ActionTypes as Technicians} from '../logisticTechnicians/actions';
import {ActionTypes as PartsLocationDashboard} from '../partsLocationDashboard/actions';

export {
  Common,
  MessageBox,
  Session,
  Menu,
  Origin,
  Order,
  Provider,
  Parameters,
  ExcelReader,
  Parts,
  ProviderConfig,
  MonthClose,
  BackOrders,
  Binning,
  Transfers,
  Warehouses,
  ItemBudget,
  PartsMaster,
  Lubricants,
  Picking,
  Transport,
  InvoiceLoad,
  PartQuotation,
  SalesAndBudgetsLoad,
  ObsolescenceParameters,
  VehiclesAvailability,
  QualityAssuranceOrders,
  ServiceReportPart,
  VehicleEfficiency,
  DealerStockOrders,
  LogisticsReports,
  WarrantiesAdmin,
  PartNumberCode,
  StockAdjustment,
  LogisticOrders,
  VehicleCombos,
  SpecialParts,
  ProviderOrders,
  VehicleHistory,
  MasterVehicle,
  CalendarTems,
  PartsReturns,
  InvoiceQuery,
  PartsCatalog,
  PartInvoices,
  PriceFactors,
  Accessories,
  VehiclesKpi,
  Warranties,
  PartsSales,
  WholeSale,
  PartAudit,
  IccMatrix,
  WaitHappy,
  Campaign,
  BoReport,
  VehAudi,
  Forms,
  Dealer,
  Sets,
  Kpis,
  Icc,
  Users,
  Liquidations,
  BudgetVehicles,
  VehicleSaleForecast,
  DailyVehiclesSalesAndStock,
  DailyVehiclesSalesAndStockSummary,
  DevicesOrders,
  Bulletins,
  LogisticAreas,
  Technicians,
  PartsLocationDashboard,
};
